import { useState } from "react";
import { Stack, Group, Button } from "@mantine/core";
import { DatePicker, TimeInput } from "@mantine/dates";
import { modals } from "@mantine/modals";
import dayjs from "dayjs";

const ScheduleModalContent = ({ onConfirm, currentSchedule }) => {
  const [date, setDate] = useState(
    currentSchedule ? dayjs(currentSchedule).format("YYYY-MM-DD") : null
  );
  const [time, setTime] = useState(
    currentSchedule ? dayjs(currentSchedule).format("HH:mm") : "12:00"
  );

  const handleConfirm = () => {
    if (!date) return;
    const [hours, minutes] = time.split(":").map(Number);
    const combined = dayjs(date).hour(hours).minute(minutes).toDate();
    onConfirm(combined);
    modals.closeAll();
  };

  //disable submit button if time is behind current time
  const isToday = date ? dayjs(date).isSame(dayjs(), "day") : false;

  const isTimeInPast = () => {
    const now = new Date();
    const [hours, minutes] = time.split(":").map(Number);
    const selected = new Date();
    selected.setHours(hours, minutes, 0, 0);
    return selected < now;
  };

  const isDisabled = !date || (isToday && isTimeInPast());

  return (
    <>
      <Stack align="center" w="100%">
        <DatePicker
          value={date}
          onChange={setDate}
          minDate={dayjs().format("YYYY-MM-DD")}
          size="md"
        />
        <TimeInput
          label="Time"
          value={time}
          onChange={(e) => setTime(e.target.value)}
          w="100%"
        />
      </Stack>
      <Group justify="flex-end" mt="md">
        <Button variant="outline" onClick={() => modals.closeAll()}>
          Cancel
        </Button>
        <Button onClick={handleConfirm} disabled={isDisabled} color="blue">
          Confirm
        </Button>
      </Group>
    </>
  );
};

export const openScheduleModal = (onConfirm, options = {}) => {
  const { currentSchedule = null } = options;

  modals.open({
    title: "Schedule campaign",
    size: "auto",
    children: (
      <ScheduleModalContent
        onConfirm={onConfirm}
        currentSchedule={currentSchedule}
      />
    ),
  });
};
